import cx from 'classnames';

const LinkContainer = ({ children, direction, className = '' }) => {
    const rowClasses = direction === 'row' && 'md:flex md:flex-wrap';
    return <div className={cx(['link-container', className, rowClasses])}>{children}</div>;
};

export default LinkContainer;
